export interface AuthStatusChangeComments {
  comment: string;
  reason: string;
  j_code: string;
  comment_type: "denial" | "query" | "query_resolution";
  commented_by: string;
  created_at: string;
}

/**
 * Validates whether the provided data is a valid array of AuthStatusChangeComments.
 *
 * This function performs runtime validation to ensure that:
 * - The data is an object and not null
 * - Every item in the array contains all required properties:
 *   comment, reason, j_code, comment_type, commented_by, and created_at
 *
 * @param data - The data to validate as an array of AuthStatusChangeComments
 *
 * @returns True if the data is a valid array of AuthStatusChangeComments, false otherwise
 *
 * @example
 * const comments = [
 *   {
 *     comment: "Authorization denied",
 *     reason: "Missing documentation",
 *     j_code: "J1234",
 *     comment_type: "denial",
 *     commented_by: "user-123",
 *     created_at: "2025-11-25 10:30:00.000000+00:00"
 *   }
 * ];
 *
 * if (isValidAuthStatusChangeComments(comments)) {
 *   // Process valid comments
 * }
 */
export const isValidAuthStatusChangeComments = (
  data: AuthStatusChangeComments[],
): boolean => {
  return (
    typeof data === "object" &&
    data !== null &&
    data.every(
      (item) =>
        "comment" in item &&
        "reason" in item &&
        "j_code" in item &&
        "comment_type" in item &&
        "commented_by" in item &&
        "created_at" in item,
    )
  );
};
